// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1IdentitySchema } from './v1/identitySchema';
import { v1IdentityUpdateSchema } from './v1/identity/updateSchema';

export const patchUserIdentityHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string().describe("Bearer token")),
});

/**
 * @description identity updated
 */
export const patchUserIdentity200Schema = z.lazy(() => v1IdentitySchema);

/**
 * @description unauthorized
 */
export const patchUserIdentity401Schema = z.unknown();

/**
 * @description validation errors
 */
export const patchUserIdentity422Schema = z.object({
  errors: z.optional(z.object({})),
});

export const patchUserIdentityMutationRequestSchema = z.lazy(() => v1IdentityUpdateSchema);

export const patchUserIdentityMutationResponseSchema = z.lazy(() => patchUserIdentity200Schema);
